import React, { useRef, useEffect } from "react";

import { ChiusuraPage } from "../routes/configurations/pergola/builder/chiusure/chiusure_page";
import { IlluminationPage } from "../routes/configurations/pergola/builder/illumination_page";
import { FiorierePage } from "../routes/configurations/pergola/builder/fioriera_page";
import { DimensionsPage } from "../routes/configurations/pergola/builder/dimensions_page";
import { useStoreSelector } from "../../hooks/StoreHooks";
import { AspectPage } from "../routes/configurations/pergola/builder/aspect_page";
import EsteticaChoices from "../routes/configurations/pergola/builder/estetica/esteticaChoice";
import { EsteticaPage } from "../routes/configurations/pergola/builder/estetica/EsteticaPage";
type FormRenderProps = {
  takeScreenshot?: () => Promise<void>;
};
export const FormRender: React.FC<FormRenderProps> = ({ takeScreenshot }) => {
    const { pergolaConfigurationBuilder } = useStoreSelector(store => store);
    const loadingOverlayRef = useRef<HTMLDivElement>(null);
    const currentStep = pergolaConfigurationBuilder.steps?.find(s => s.isActive)?.slug || "dimensioni";
    useEffect(() => {
        if (loadingOverlayRef.current) {
            loadingOverlayRef.current.style.display = "none";
        }
    }, [currentStep]);

    let CurrentComponent;
    switch (currentStep) {
        case "estetica":
            CurrentComponent = EsteticaPage;
            break;
        case "illuminazioni":
            CurrentComponent = IlluminationPage;
            break;
        case "dimensioni":
            CurrentComponent = DimensionsPage;
            break;
        case "fioriere":
            CurrentComponent = FiorierePage;
            break;
        case "aspetto":
            CurrentComponent = AspectPage;
            break;
        default:
            CurrentComponent = ChiusuraPage;
            break;
    }

    return (
        <>
            <div ref={loadingOverlayRef} style={{ display: "none" }}>
            Loading...
            </div>

            {currentStep === "estetica" ? (
            <EsteticaPage takeScreenshot={takeScreenshot} />
            ) : (
            <CurrentComponent />
            )}
        </>
    );
};
